// "Told on their phone" (30-day list row 17): when a record lands on someone, the confirmation
// says whether that person has a phone registered for pushes. The alert itself is written by
// the server; this only reads whether there is a device to deliver it to.
import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../firebase';
import type { Session } from '../auth';

const cache = new Map<string, { at: number; has: boolean | null }>();
/** true = at least one device, false = none, null = could not tell (a field role cannot read another person's devices). */
export async function hasPhone(s: Session, uid: string | null | undefined): Promise<boolean | null> {
  if (!uid || uid.startsWith('contact:')) return null;
  const c = cache.get(uid); if (c && Date.now() - c.at < 10 * 60_000) return c.has;
  let has: boolean | null = null;
  try { has = !(await getDocs(query(collection(db, `${s.paths.users}/${uid}/devices`), limit(1)))).empty; } catch { has = null; }
  cache.set(uid, { at: Date.now(), has });
  return has;
}
/** The words after an assignment: "Matt will see it on their phone" / "Matt has no phone set up; it waits on their Today screen". */
export function toldText(name: string | null | undefined, has: boolean | null): string {
  const first = (name || 'They').split(' ')[0];
  if (has === true) return `${first} will see it on their phone`;
  if (has === false) return `${first} has no phone set up for pushes; it is on their Today screen`;
  return `${first} is told`;
}
